<template>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mb-4">
        <Head :title="topic.name" />
        <piped-title
            :first="$t('apartments.apartment') + ' ' + apartment.number"
            :second="topic.name"
            :pages="breadcrumbPages"
        ></piped-title>
    </div>

    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <!-- Topic Header -->
        <topics-header
            :topic="topic"
            :supplier="supplier"
            :supplier-contact="supplierContact"
            :show-budget="showBudget"
        />

        <!-- Order Modification Section -->
        <order-modification-table
            :topic="topic"
            :order-modifications="orderModifications"
            show-modification-route="clients.topics.order-modifications.show"
            :show-budget="showBudget"
            :is-budget-based="isBudgetBased"
        />


        <!-- Option-Sets Section -->
        <set-selection
            v-for="values in sets"
            :disabled="topic.state === 'completed'"
            :topic="topic"
            :values="values"
            route-for-select="clients.topics.sets.select"
            route-for-clear="clients.topics.sets.clear"
            :key="values.set.uuid"
        />

        <!-- Documents Section -->
        <document-table :documents="documents"></document-table>
    </div>
</template>

<script>
import PipedTitle from "@/Shared/Components/PipedTitle";
import { Head } from "@inertiajs/inertia-vue3";
import {
    CheckIcon,
    CloudDownloadIcon,
    CloudUploadIcon,
    PaperAirplaneIcon,
    RefreshIcon,
    TagIcon,
    TrashIcon,
    XIcon,
} from "@heroicons/vue/outline";
import OfferTable from "@/Pages/Topics/Components/OfferTable";
import DocumentTable from "@/Shared/Components/Documents/DocumentTable";
import SetSelection from "@/Pages/Apartments/Components/SetSelection";
import ClientApartmentLayout from "@/Layouts/ClientApartmentLayout";
import TopicsHeader from "@/Shared/Components/Topics/TopicsHeader";
import OrderModificationTable from "@/Pages/Topics/Components/OrderModificationTable.vue";

export default {
    name: "Show.vue",
    components: {
        Head,
        OrderModificationTable,
        TopicsHeader,
        OfferTable,
        DocumentTable,
        PipedTitle,
        SetSelection,
        CloudUploadIcon,
        CloudDownloadIcon,
        TrashIcon,
        PaperAirplaneIcon,
        RefreshIcon,
        CheckIcon,
        XIcon,
        TagIcon,
    },
    layout: ClientApartmentLayout,
    props: [
        "topic",
        "apartment",
        "orderModifications",
        "supplier",
        "supplierContact",
        "documents",
        "sets",
        // Auftrag 2026-08-16, Entscheid 7 und Ableitung «je Zielgruppe»: der
        // Käufer sieht im Thema SEINEN Spaltensatz — `feeCalculation.showBudget`
        // ist serverseitig bereits für die Zielgruppe "buyer" aufgelöst.
        "feeCalculation"
    ],
    computed: {
        showBudget() {
            return this.feeCalculation ? this.feeCalculation.showBudget : true;
        },
        isBudgetBased() {
            return this.feeCalculation ? this.feeCalculation.isBudgetBased : false;
        },
        breadcrumbPages() {
            return [
                {
                    name: this.$t("projects.apartments"),
                    href: this.route("clients.apartments.index"),
                    current: false,
                },
                {
                    name: `${this.$t("apartments.apartment")} ${this.apartment.number}`,
                    href: this.route("clients.apartments.show", { apartment: this.apartment.uuid }),
                    current: false,
                },
                {
                    name: this.topic.name,
                    href: this.route("clients.apartments.topics.show", { apartment: this.apartment.uuid, topic: this.topic.uuid }),
                    current: true,
                },
            ];
        },
    },
};
</script>

<style scoped></style>
